module.exports = function isString(x) {
  return typeof x === 'string';
};